import React, { useState } from 'react'
import './Gallery.css'
import Preview from './Preview'

function Gallery() {
  const [preview,setPreview] = useState(false)

  const openPhoto = (value) => {
    setPreview(true)
  }

  return (
    <div className='gallery-container'>
      <div className='photo-container' onClick={()=>openPhoto("https://wallpapercave.com/wp/Mn9KEYe.jpg")}>
        <div>
          <img src="https://wallpapercave.com/wp/Mn9KEYe.jpg" className='photo-image' />
        </div>
        <div className='photo-info'>
          <div>Lorem ipsum dolor sit amet.</div>
        </div>
      </div>

      <div className='photo-container' onClick={()=>openPhoto("https://wallpapercave.com/wp/Mn9KEYe.jpg")}>
        <div>
          <img src="https://wallpapercave.com/wp/Mn9KEYe.jpg" className='photo-image' />
        </div>
        <div className='photo-info'>
          <div>Lorem ipsum dolor sit amet.</div>
        </div>
      </div>

      <div className='photo-container' onClick={()=>openPhoto("https://wallpapercave.com/wp/Mn9KEYe.jpg")}>
        <div>
          <img src="https://wallpapercave.com/wp/Mn9KEYe.jpg" className='photo-image' />
        </div>
        <div className='photo-info'>
          <div>Lorem ipsum dolor sit amet.</div>
        </div>
      </div>

      <div className='photo-container' onClick={()=>openPhoto("https://wallpapercave.com/wp/Mn9KEYe.jpg")}>
        <div>
          <img src="https://wallpapercave.com/wp/Mn9KEYe.jpg" className='photo-image' />
        </div>
        <div className='photo-info'>
          <div>Lorem ipsum dolor sit amet.</div>
        </div>
      </div>

      {
        preview===true && <Preview preview={preview} setPreview={setPreview}/>
      }
    </div>
  )
}

export default Gallery